import Model from '@/models/Model.js';

export default class RolePermission extends Model {
    static entity = 'role_has_permissions';

    static primaryKey = ['role_id', 'permission_id'];

    static fields() {
        return {
            role_id: this.attr(null),
            permission_id: this.attr(null),

            role: this.belongsTo('roles', 'role_id'),
            permission: this.belongsTo('permissions', 'permission_id'),
        };
    }
}
